(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const consent = document.querySelector('[data-consent]');
  const addToCart = document.querySelector('button[name="add"]');

  if (!consent || !addToCart) return;

  addToCart.disabled = true;

  consent.addEventListener('change', () => {
    addToCart.disabled = !consent.checked; // disable the add to cart button when the checkbox is unchecked
  });
});
  } catch(e) { console.error(e); }
})();

})();
